import { Ref } from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';
import { WarningCircle } from '../icons';

interface FieldErrorMessageProps {
  text: string;
  /** Lets the invalid field name this message as its description (aria-describedby). */
  id?: string;
  /** Announces the message to screen readers as soon as it appears, wherever focus is. */
  announce?: boolean;
  ref?: Ref<HTMLDivElement>;
}

const FieldErrorMessageWrapper = styled(Flex)`
  margin-top: 5px;
  color: var(--clr-inline-error);
  p {
    font-style: italic;
    font-size: 11px;
    line-height: 15px;
  }
  .icon {
    flex-shrink: 0;
    font-size: 12px;
    svg path {
      fill: currentColor;
    }
  }
`;

const FieldErrorMessage = ({ text, id, announce = false, ref }: FieldErrorMessageProps) => {
  return (
    <FieldErrorMessageWrapper
      id={id}
      ref={ref}
      role={announce ? 'alert' : undefined}
      data-testid="field-error-message"
      gap={2}
    >
      <WarningCircle />
      <p>{text}</p>
    </FieldErrorMessageWrapper>
  );
};

export default FieldErrorMessage;
